const PermissionsEnum = {};

PermissionsEnum.EDIT_INSTRUMENTS = 'EditInstruments';
PermissionsEnum.VIEW_ALL_INSTRUMENTS = 'ViewAllInstruments';
PermissionsEnum.SEND_FILES = 'TransferFilesToInstrument';
PermissionsEnum.RECEIVE_FILES = 'TransferFilesFromInstrument';
PermissionsEnum.VIEW_USERS = 'ViewUsers';
PermissionsEnum.EDIT_USERS = 'EditUsers';
PermissionsEnum.VIEW_REGIONS = 'ViewRegions';
PermissionsEnum.EDIT_REGIONS = 'EditRegions';
PermissionsEnum.VIEW_GROUPS = 'ViewGroups';
PermissionsEnum.EDIT_GROUPS = 'EditGroups';
PermissionsEnum.VIEW_SYSTEM_SETTINGS = 'ViewSystemSettings';
PermissionsEnum.EDIT_SYSTEM_SETTINGS = 'EditSystemSettings';
PermissionsEnum.VIEW_PERMISSIONS = 'ViewPermissions';
PermissionsEnum.EDIT_PERMISSIONS = 'EditPermissions';
PermissionsEnum.VIEW_ALERT_CONFIGURATION = 'ViewStatusAlertConfiguration';
PermissionsEnum.EDIT_ALERT_CONFIGURATION = 'EditStatusAlertConfiguration';
PermissionsEnum.VIEW_CHAT = 'ViewChat';
PermissionsEnum.VIEW_DESKTOP_SHARING = 'ViewDesktopSharing';
PermissionsEnum.VIEW_INSTRUMENT_LOGBOOK = 'ViewInstrumentLogbook';
PermissionsEnum.VIEW_USER_AUDIT_LOGS = 'ViewUserAuditLogs';
PermissionsEnum.VIEW_INSTRUMENT_AUDIT_LOGS = 'ViewInstrumentAuditLogs';
PermissionsEnum.EDIT_INSTRUMENT_CONNECTION = 'EditInstrumentConnection';
PermissionsEnum.VIEW_ALERTS = 'ViewAlerts';
PermissionsEnum.EDIT_ALERTS = 'EditSystemAlertConfiguration';
PermissionsEnum.VIEW_FLEETS = 'ViewFleets';
PermissionsEnum.VIEW_FLEETDETAILS = 'ViewFleetDetails';
PermissionsEnum.VIEW_ALL_USERS_FOR_GROUP_ASSIGNMENT = 'ViewAllUsersForGroupAssignment';
PermissionsEnum.REMOVE_INSTRUMENTS_FROM_GROUP = 'RemoveInstrumentsFromGroup';
PermissionsEnum.VIEW_UPDATE_MANAGEMENT = 'ViewUpdateManagement';
PermissionsEnum.VIEW_UPDATE_JOBS = 'ViewUpdateJobs';
PermissionsEnum.CREATE_UPDATE_JOBS = 'CreateUpdateJobs';
PermissionsEnum.VIEW_COMMAND_JOBS = 'ViewCommandJobs';
PermissionsEnum.CREATE_COMMAND_JOBS = 'CreateCommandJobs';
PermissionsEnum.VIEW_BILLING = 'ViewBilling';
PermissionsEnum.ASSIGN_USER_PERMISSIONS = 'AssignUserPermissions';
PermissionsEnum.RELEASE_AUTHORITY = 'ReleaseAuthority';
PermissionsEnum.VIEW_MANUFACTURING_DASHBOARD = 'ViewManufacturingDashboard';
PermissionsEnum.DELETE_ALL_SUP_FILES = 'DeleteAllSupFiles';
PermissionsEnum.VIEW_RAW_INSTRUMENT_TELEMETRY = 'ViewRawInstrumentTelemetry';
PermissionsEnum.VIEW_CALCULATED_INSTRUMENT_TELEMETRY = 'ViewCalculatedInstrumentTelemetry';

export default PermissionsEnum;
